import { render, staticRenderFns } from "./remark.vue?vue&type=template&id=63296a39&scoped=true"
import script from "./remark.vue?vue&type=script&lang=js"
export * from "./remark.vue?vue&type=script&lang=js"
import style0 from "./remark.vue?vue&type=style&index=0&id=63296a39&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63296a39",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63296a39')) {
      api.createRecord('63296a39', component.options)
    } else {
      api.reload('63296a39', component.options)
    }
    module.hot.accept("./remark.vue?vue&type=template&id=63296a39&scoped=true", function () {
      api.rerender('63296a39', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/scheduler/components/remark.vue"
export default component.exports